let resetMode = 'username';
let resetToken = null;
let resetIdentifierValue = '';

$(document).ready(function () {
    $('#resetModeUsername').on('click', function (e) {
        e.preventDefault();
        setResetMode('username');
    });

    $('#resetModeEmail').on('click', function (e) {
        e.preventDefault();
        setResetMode('email');
    });

    $('#resetBackToIdentifyBtn').on('click', function (e) {
        e.preventDefault();
        resetToken = null;
        resetIdentifierValue = '';
        $('.otp-input').val('');
        $('#stepOtp').addClass('d-none');
        $('#stepPassword').addClass('d-none');
        $('#stepIdentify').removeClass('d-none');
    });

    $('#sendResetOtpBtn').on('click', async function () {
        const identifier = getResetIdentifier();
        const button = $(this);

        if (!isResetIdentifierValid(identifier)) {
            return;
        }

        const turnstileToken = $('[name="cf-turnstile-response"]').val();
        if ($('[data-sitekey]').length && (!turnstileToken || turnstileToken.trim() === '')) {
            notify('error', 'Please complete the verification challenge');
            return;
        }

        btnLoader.start(button, 'Sending...');

        const payload = { username: identifier };
        if (turnstileToken) {
            payload.turnstile_token = turnstileToken;
        }

        const res = await fetch('/api/auth/requestPasswordReset', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload)
        });

        const data = await res.json();

        btnLoader.stop(button);

        if (!data.success) {
            resetTurnstile();
            notify('error', data.message || 'Unable to send reset code');
            return;
        }

        resetIdentifierValue = identifier;

        const maskedTarget = data.maskedEmail || data.maskedPhone || 'your account';
        const channelLabel = data.channel === 'email' ? 'email' : 'phone';

        $('#resetOtpLabel').html(
            'A 6-digit code has been sent to your ' + channelLabel + ' at <strong>' + maskedTarget + '</strong>.'
        );

        $('#stepIdentify').addClass('d-none');
        $('#stepOtp').removeClass('d-none');
        $('.otp-input').val('').first().focus();
    });

    $('#verifyResetOtpBtn').on('click', async function () {
        let code = '';
        $('.otp-input').each(function () {
            code += $(this).val();
        });

        if (code.length !== 6) {
            notify('error', 'Please enter all 6 digits');
            return;
        }

        if (!resetIdentifierValue) {
            notify('error', 'Session expired. Please start again.');
            $('#stepOtp').addClass('d-none');
            $('#stepIdentify').removeClass('d-none');
            return;
        }

        btnLoader.start($(this), 'Verifying...');

        const res = await fetch('/api/auth/verifyPasswordOtp', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ username: resetIdentifierValue, otp: code })
        });

        const data = await res.json();

        btnLoader.stop($(this));

        if (!data.success) {
            notify('error', data.message || 'Invalid code');
            return;
        }

        resetToken = data.token;

        $('#stepOtp').addClass('d-none');
        $('#stepPassword').removeClass('d-none');
    });

    $('#resendResetOtpBtn').on('click', async function (e) {
        e.preventDefault();

        if (!resetIdentifierValue) {
            notify('error', 'Session expired. Please start again.');
            return;
        }

        btnLoader.start($(this), 'Sending...');

        const res = await fetch('/api/auth/requestPasswordReset', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ username: resetIdentifierValue, resend: true })
        });

        const data = await res.json();

        btnLoader.stop($(this));

        if (!data.success) {
            notify('error', data.message || 'Unable to resend code');
            return;
        }

        notify('info', 'A new code has been sent');
    });

    const RESET_PASSWORD_RULE_IDS = ['resetRuleLength', 'resetRuleUppercase', 'resetRuleSymbol'];

    $('#newPassword').on('input', function () {
        const password = $(this).val();
        $('#resetPasswordHelper').show();
        const req = PasswordHelper.checkRequirements(password);
        PasswordHelper.applyRuleIcons(RESET_PASSWORD_RULE_IDS, req);
    });

    function trySubmitNewPassword() {
        const pass = $('#newPassword').val().trim();
        const confirm = $('#confirmPassword').val().trim();

        if (!pass || !confirm) {
            notify('error', 'Please enter both fields');
            return;
        }

        const req = PasswordHelper.checkRequirements(pass);
        if (!req.valid) {
            notify('error', 'Password must be at least 8 characters with an uppercase letter and a symbol');
            $('#resetPasswordHelper').show();
            PasswordHelper.applyRuleIcons(RESET_PASSWORD_RULE_IDS, req);
            return;
        }

        if (pass !== confirm) {
            notify('error', 'Passwords do not match');
            return;
        }

        return pass;
    }

    $('#newPassword, #confirmPassword').on('keydown', function (e) {
        if (e.key === 'Enter') {
            e.preventDefault();
            $('#submitNewPasswordBtn').trigger('click');
        }
    });

    $('#submitNewPasswordBtn').on('click', async function (e) {
        e.preventDefault();
        const pass = trySubmitNewPassword();
        if (!pass) return;

        btnLoader.start($(this), 'Resetting...');

        const res = await fetch('/api/auth/resetPassword', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ token: resetToken, password: pass })
        });

        const data = await res.json();

        btnLoader.stop($(this));

        if (!data.success) {
            notify('error', data.message || 'Unable to reset password');
            return;
        }

        notify('success', 'Password reset successfully');
        setTimeout(() => window.location.href = '/login', 1200);
    });

    OTPHelper.initOtpFields('.otp-input');
});


function setResetMode(mode) {
    resetMode = mode === 'email' ? 'email' : 'username';
    const isEmail = resetMode === 'email';

    $('#resetModeUsername').toggleClass('active', !isEmail).attr('aria-selected', !isEmail ? 'true' : 'false');
    $('#resetModeEmail').toggleClass('active', isEmail).attr('aria-selected', isEmail ? 'true' : 'false');
    $('#resetIdentifierUsername').toggleClass('d-none', isEmail);
    $('#resetIdentifierEmail').toggleClass('d-none', !isEmail);

    if (isEmail) {
        $('#resetEmail').trigger('focus');
    } else {
        $('#resetUsername').trigger('focus');
    }
}


function getResetIdentifier() {
    if (resetMode === 'email') {
        return $('#resetEmail').val().trim().toLowerCase();
    }

    return $('#resetUsername').val().trim();
}


function isResetIdentifierValid(identifier) {
    if (resetMode === 'email') {
        if (!identifier || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(identifier)) {
            notify('error', 'Please enter a valid email address');
            return false;
        }
        return true;
    }

    if (!identifier || identifier.length < 3) {
        notify('error', 'Please enter a valid username');
        return false;
    }

    return true;
}


function resetTurnstile() {
    try {
        if (typeof turnstile !== 'undefined' && typeof turnstile.reset === 'function') {
            turnstile.reset();
        }
    } catch (e) {}
}
